import {Component, OnInit, Input, ElementRef, AfterViewInit, HostListener} from '@angular/core';
import {UserNotification} from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import * as moment from 'moment';
import * as jq from 'jquery';
import {NotificationService} from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {OverlayPanel} from 'primeng/overlaypanel';
import {Notification} from 'projects/app-misc/src/app/modules/notification/data/notification';
import {MatDialog} from '@angular/material/dialog';
import {ProjectInfoComponent} from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TasksService} from '../../../../../../../desktop/src/app/modules/home-page/data/tasks/tasks.service';
import {
  TaskEditDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/task-edit-dialog/task-edit-dialog.component';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  providers: [DeviceDetectorService]
})
export class NotificationComponent implements OnInit, AfterViewInit {
  @Input()
  userNfs: UserNotification;

  @Input()
  history = false;

  @Input()
  notificationOP: OverlayPanel

  @Input()
  fullPage = false;

  statusMessage: string;

  timeToShow: string;

  readStatus: boolean;

  isMobile = false;
  isTablet = false;

  constructor(
    protected elementRef: ElementRef,
    protected dialog: MatDialog,
    protected projectService: ProjectService,
    protected tasksService: TasksService,
    protected deviceDetectorService: DeviceDetectorService,
    protected notificationService: NotificationService
  ) {
  }

  ngOnInit() {
    this.isMobile = this.deviceDetectorService.isMobile();
    this.isTablet = this.deviceDetectorService.isTablet();

    const a = moment();
    const b = moment(this.userNfs.notification.createdTime);

    if (a.diff(b, 'days') < 7) {
      this.timeToShow = moment(this.userNfs.notification.createdTime).calendar();
    } else {
      const timeFormat = 'h:mm A MMM D ';

      // if (this.fullPage) timeFormat = 'LT';

      this.timeToShow = moment(this.userNfs.notification.createdTime).format(timeFormat);
    }


    if (this.userNfs.notification.message) {
      const str = this.userNfs.notification.message;
      this.statusMessage = str
        .replace(/<(\w+)([^<]*)>/gim, '<span class=\"$1\"$2>')
        .replace(/<\/(\w+)>/gim, '</span>');
    }

    this.readStatus = this.userNfs.readStatus;

  }

  ngAfterViewInit() {
    const el = this.elementRef.nativeElement as HTMLElement
    const nfEl = jq(el.getElementsByClassName('project'))

    // tslint:disable-next-line: deprecation
    nfEl.click(jQEvent => {
      // this.openProjectWindow()
    })
  }


  @HostListener('click', ['$event'])
  nfsClick() {
    if (!this.userNfs.readStatus) {
      this.toggleReadStatus();
    }

    if (this.userNfs.notification.clazz === 'TASK_NOTIFICATION') {
      this.openTask()
    } else {
      this.openProjectWindow()
    }
  }

  openTask() {
    this.tasksService.getTask(this.userNfs.notification.taskId, this.userNfs.notification.taskClazz).subscribe(task => {

      const dialogRef = this.dialog.open(TaskEditDialogComponent, {
        data: {
          task,
          projectId: task.project ? task.project.id : null,
          projectName: task.project ? task.project.name : null,
          buttonLabel: 'Save'
        },
        panelClass: 'task-edit-dialog',
        disableClose: false
      });
    })
  }

  openProjectWindow(): void {
    if (this.userNfs.user) {

      if (this.notificationOP) {
        this.notificationOP.hide();
      }

      let projectWindow = ProjectWindowComponent as any;

      let panelClass = 'project-window-dialog'

      if (this.isMobile || this.isTablet) {
        projectWindow = ProjectInfoComponent
        panelClass = 'project-info-dialog'
      }

      const dialogRef = this.dialog.open(projectWindow, {
        data: {
          projectNumber: this.userNfs.notification.projectId,
          notification: this.userNfs.notification

        },
        panelClass
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  toggleReadStatus(event?) {
    if(event){
      event.stopPropagation();
    }

    if (!this.readStatus) {
      this.notificationService.markNotificationAsRead(this.userNfs.id).subscribe(emit => {
        this.notificationService.unreadMentions.next()
      })
      this.readStatus = true;
    }
  }

}
